// extracted by mini-css-extract-plugin
export var VisitSpecificFacilities = "VisitSpecificFacilities-module--VisitSpecificFacilities--6e598";
export var image = "VisitSpecificFacilities-module--image--ff96f";
export var textContent = "VisitSpecificFacilities-module--textContent--a5c0c";